import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Badge, ItemIcon, Type } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

import type { WaterfallProvider } from "../../types/contacts-providers";

type AvailableProviderCardProps = {
    readonly provider: WaterfallProvider;
};

export const AvailableProviderCard = ({ provider }: AvailableProviderCardProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="12px"
            alignItems="flex-start"
            padding="14px 12px"
            data-automation={`contacts-waterfall-provider-${provider.domain}`}
            background={colorsPalettes.bluegrey[100]}
            borderRadius="6px"
        >
            <Flex flexShrink="0" opacity={0.45}>
                <ItemIcon
                    iconType={Type.Website}
                    iconSrc={getFaviconUrl(provider.domain)}
                />
            </Flex>
            <Stack
                flex="1"
                minWidth="0"
                gap="6px"
            >
                <Flex
                    gap="6px"
                    alignItems="center"
                >
                    <Text
                        fontVariant="subtitle1"
                        color={colorsPalettes.bluegrey[600]}
                    >
                        {provider.name}
                    </Text>
                    <Badge type="coming soon" />
                </Flex>
                <Text
                    fontVariant="listItem3"
                    color={colorsPalettes.carbon[300]}
                    opacity={0.45}
                >
                    {translate(provider.descriptionKey)}
                </Text>
            </Stack>
        </Flex>
    );
};
